export default class StartOverlay {

    constructor(scene) {
        this.scene = scene;

        //Create a new texture for the gradient background, if one doesn't exist
        let texture = scene.textures.getFrame('gradient');
        if (!texture) {
            texture = scene.textures.createCanvas('gradient', scene.innerWidth, scene.innerHeight);
        } else {
            texture = texture.texture;
        }

        let context = texture.getContext();
        let grd = context.createLinearGradient(0, 0, 0, scene.innerHeight);

        //Draw the gradient
        grd.addColorStop(0, '#18264a');
        grd.addColorStop(1, '#2b4895');

        //Because of WebGL, we need to refresh the texture.
        texture.refresh();

        //Create the overlay sprite
        this.overlay = scene.add.image(scene.centerX, scene.centerY, 'gradient');
        this.overlay.setAlpha(0.96);

        if (!scene.is_mobile) {
            //Add the heading text
            this.heading = scene.make.text({
                x: scene.centerX,
                y: scene.percentToPixels('height', 30),
                text: scene.trans('start.heading', 'Dancer is ready to disco!'),
                style: {
                    font: '700 48px "Scandinavian", sans-serif',
                    fill: '#ffffff'
                }
            });
            this.heading.setOrigin(0.5, 0.5);
        }

        //Add the information text
        let infoText = scene.trans('start.info_1', 'Turn on the sound!') + '\n' + scene.trans('start.info_2', 'Use the arrow keys to track the beat') + '\n' + scene.trans('start.info_3', 'and make some wild moves');
        if (scene.game.record_mode) {
            infoText = 'Record mode enabled\nOld arrows are disabled in this mode\nUse the arrow keys, to record the new arrow position';
        }
        this.info = scene.make.text({
            x: scene.centerX,
            y: scene.centerY + (scene.is_mobile ? 0 : scene.percentToPixels('height', 15)),
            text: infoText,
            style: {
                weight: 400,
                font: (scene.is_mobile ? '18' : '22') + 'px "Scandinavian", sans-serif',
                fill: '#ffffff',
                align: 'center'
            },
        });
        this.info.setOrigin(0.5, 0.5)

        if (!scene.is_mobile) {
            this.keyboard = scene.add.sprite(scene.centerX, scene.centerY + scene.percentToPixels('height', 30), 'keyboard');

            if (scene.dpr > 1) {
                this.keyboard.setScale(this.keyboard.scaleX / scene.dpr);
            }
        }

        //Create the start button sprite
        let x = scene.centerX;
        let y = scene.centerY;

        if (scene.is_mobile) {
            y = scene.innerHeight - scene.percentToPixels('height', 25)
        }

        scene.textures.remove('start-button');

        let startButton = scene.add.graphics();
        startButton.fillStyle(0xCDDA00, 1)
        startButton.fillCircle(50, 50, 50);
        startButton.generateTexture('start-button', 100, 100);
        startButton.destroy();

        this.start_button = scene.add.sprite(x, y, 'start-button');
        this.start_button.setInteractive();

        this.start_button.text = scene.make.text({
            x: x,
            y: y,
            text: scene.trans('start.start_button', "START"),
            style: {
                font: '18px "Scandinavian", sans-serif',
                fill: '#152648',
                align: 'center'
            },
        });
        this.start_button.text.setOrigin(0.5, 0.5)

        //Change the cursor to pointer, when hovering over start button
        this.start_button.on('pointerover', () => {
            scene.sys.canvas.style.cursor = 'pointer';
        });

        //Change the cursor back to normal, when not hovering over start button
        this.start_button.on('pointerout', () => {
            scene.sys.canvas.style.cursor = 'inherit';
        });

        //Start the game, when the start button is pressed
        this.start_button.on('pointerup', () => {
            dataLayer.push({
                event: 'GAevent',
                eventCategory: 'LP - Xmasdancer',
                eventAction: 'Game start',
                eventLabel: 'Start continue ; Lang:' + localStorage.getItem('locale'),
                nonInteraction: false
            });

            //Create the countdown counter
            this.countdown = scene.add.graphics();
            this.countdown.time = 0;
            this.countdown.iteration = 1;
            this.countdown.start = Date.now();
            this.countdown.text = this.scene.make.text({
                x: this.scene.centerX,
                y: this.scene.centerY,
                text: '3',
                style: {
                    weight: 400,
                    font: '24px "Scandinavian", sans-serif',
                    fill: '#ffffff'
                }
            });
            this.countdown.text.setOrigin(0.5, 0.5);

            //Destroy the start button and overlay texts
            if (this.heading) this.heading.destroy();
            this.info.destroy();
            this.start_button.destroy();
            this.start_button.text.destroy();
            this.overlay.destroy();

            if (!scene.is_mobile) {
                this.keyboard.destroy();
            }

            //Start the game
            this.scene.startGame();

            //Revert the cursor back, just in case
            scene.sys.canvas.style.cursor = 'inherit';
        });
    }

    destroy() {
        if (this.countdown.text) this.countdown.text.destroy();
        if (this.countdown) this.countdown.destroy();
    }

    update() {
        if (this.countdown) {
            this.countdown.time = parseFloat(parseFloat((Date.now() - this.countdown.start) / 1000).toFixed(2));
            this.countdown.clear();
            this.countdown.lineStyle(8, 0xCDDA00, 1);
            this.countdown.beginPath();

            let radianFrom = Phaser.Math.DegToRad(0);
            let radianTo = Phaser.Math.DegToRad(this.countdown.time <= this.countdown.iteration ? ((this.countdown.time - (this.countdown.iteration - 1)) * 360) : 360);

            this.countdown.arc(this.scene.centerX, this.scene.centerY, 40, radianFrom, radianTo, false);
            this.countdown.strokePath();

            if (this.countdown.time >= this.countdown.iteration) {
                this.countdown.iteration++;

                if (this.countdown.iteration === 3) {
                    //Play the rewind sound

                    if (this.scene.audio.rewind) {
                        this.scene.audio.rewind.play();
                    }
                }

                this.countdown.text.setText(3 - (this.countdown.iteration - 1))

                if (this.countdown.iteration > 3) {
                    this.destroy();

                    //I know it's bad, please don't judge me
                    delete this.scene.start_overlay;
                }
            }

        }
    }
}